/**
 * 大屏模块接口
 * name：接口名称
 * url：接口api
 * method：接口请求方法，默认GET
 * defaultParams：默认参数
 */

export default [
  // 经济主体
  {
    name: 'getEconomicSubject',
    url: '/api/back-end-api/v1/screen/economic-subject',
    defaultParams: {
      year: '',
    },
  },
  // 企业排名
  {
    name: 'getEnterpriseRanking',
    url: '/api/back-end-api/v1/screen/enterprise-ranking',
    defaultParams: {
      type: 0, // 0 世界500强，1 全国500，2 全国制造业，3 全国服务业，4 广东民营企业
      year: '',
    },
  },
  // 广东生产总值及增速
  {
    name: 'getGDPGrowth',
    url: '/api/back-end-api/v1/screen/gd-gdp-growth',
    defaultParams: {
      startYear: 2020,
      endYear: 2021,
    },
  },
  // 广东省民营经济生产总值
  {
    name: 'getGDPPrivateEconomy',
    url: '/api/back-end-api/v1/screen/gd-gdp-private-economy',
    defaultParams: {
      caliber: '', // 维度：行业、产业
      year: '',
    },
  },
  // 广东省民营经济生产总值-年份下拉
  {
    name: 'getGDPPrivateEconomyYear',
    url: '/api/back-end-api/v1/screen/gd-gdp-private-economy-year',
    defaultParams: {
      caliber: '', // 维度：行业、产业
      year: '',
    },
  },
  // 广东高新企业
  {
    name: 'getHighTech',
    url: '/api/back-end-api/v1/screen/gd-high-tech',
    defaultParams: {
      startYear: 2016,
      endYear: 2022,
    },
  },
  // 广东省经济进出口额
  {
    name: 'getInoutVolume',
    url: '/api/back-end-api/v1/screen/gd-inout-volume',
    defaultParams: {
      caliber: '', // 维度：进口、出口
      startYear: 2016,
      endYear: 2021,
    },
  },
  // 广东民营企业主体
  {
    name: 'getPrivateEnterprises',
    url: '/api/back-end-api/v1/screen/gd-private-enterprises',
    defaultParams: {
      caliber: '', // 维度：单位、从业人数
      startYear: 2016,
      endYear: 2021,
    },
  },
  // 广东省民营固定资产投资
  {
    name: 'getPrivateInvestment',
    url: '/api/back-end-api/v1/screen/gd-private-investment',
    defaultParams: {
      startYear: 2016,
      endYear: 2021,
    },
  },
  // 广东省民营税金
  {
    name: 'getPrivateTax',
    url: '/api/back-end-api/v1/screen/gd-private-tax',
    defaultParams: {
      startYear: 2016,
      endYear: 2021,
    },
  },
  // 广东专精特新企业
  {
    name: 'getSpecialNewEnterprise',
    url: '/api/back-end-api/v1/screen/gd-zjtx',
    defaultParams: {
      startYear: 2020,
      endYear: 2022,
    },
  },
  // 具体企业列表数据
  {
    name: 'getSpecialNewEnterpriseList',
    url: '/api/back-end-api/v1/screen/gd-zjtx/page',
    defaultParams: {
      cityName: '',
      enterpriseName: '',
      year: '',
    },
  },
  // -小巨人企业 - 未使用
  {
    name: 'getLitterEnterpriseList',
    url: '/api/back-end-api/v1/screen/gd-xjr/page',
    defaultParams: {},
  },
  // 省工商联合作银行金融服务情况
  {
    name: 'getCooperativeBank',
    url: '/api/back-end-api/v1/screen/gsl-cooperative-banks',
    defaultParams: {
      startYear: 2018,
      endYear: 2021,
    },
  },
  // 地图地区指标数据
  {
    name: 'getMapQuota',
    url: '/api/back-end-api/v1/screen/map-quota',
    defaultParams: {
      name: '',
    },
  },
  // 地图全国全量企业500强数据
  {
    name: 'getMapCountryEnQuota',
    url: '/api/back-end-api/v1/screen/map-country-quota',
  },
  // 地图广东全量企业500强数据
  {
    name: 'getMapCityEnQuota',
    url: '/api/back-end-api/v1/screen/private-enterprise-gd-statistics',
  },
  // 地图地市企业500强-列表
  {
    name: 'getMapCityEnList',
    url: '/api/back-end-api/v1/screen/gd-private-enterprises/page',
  },
  // 地图地区会员数统计 - 广东
  {
    name: 'getGdMembersData',
    url: '/api/back-end-api/v1/screen/membership-gd-statistics',
  },
  // 会员数统计
  {
    name: 'getMembershipStatistics',
    url: '/api/back-end-api/v1/screen/membership-statistics',
    defaultParams: {
      name: '',
    },
  },
];
